<aside class="menu">
  <ng-container authorize-context [resource]="'ADMIN'">
    <ul class="menu-list" *authorize-read-write>
      <li><a routerLinkActive="is-active" routerLink="/trusts-manager">Certifikatsutfärdare</a></li>
      <li><a routerLinkActive="is-active" routerLink="/keymanager">Nyckelhantering</a></li>
      <li><a routerLinkActive="is-active" routerLink="/privileges">Behörighet</a></li>
      <li><a routerLinkActive="is-active" routerLink="/rp-information">RP Information</a></li>
    </ul>
  </ng-container>
  <p class="menu-label">Hjälp</p>
  <ul class="menu-list">
    <li><a routerLinkActive="is-active" routerLink="/user-information">Användarinformation</a></li>
    <li *ngIf="config"><a [href]="config?.userManualUrl" target="_blank">Användarhandbok</a></li>
  </ul>
</aside>

<div class="version">
  <ng-container *ngIf="applicationInfo">
    <span>Version: {{ applicationInfo?.build?.version }}-{{ applicationInfo?.git?.commit?.id }}</span>
    <span>Plattformsversion: {{ applicationInfo?.build?.common?.version }}</span>
  </ng-container>
</div>
